import React from 'react';
import { renderChildren } from '@fiverr-private/ui_utils';
import { Center } from '@fiverr-private/layout_components';
import { InputGroupChildProps } from '../types';
import { SUFFIX_ID } from '../constants';

const InputSuffix = ({ children, disabled, dataTrackTag = 'input_suffix', dataTrackValue }: InputGroupChildProps) => (
  <Center dataTrackTag={dataTrackTag} dataTrackValue={dataTrackValue} paddingLeft="1" height="100%">
    {renderChildren(children, { disabled })}
  </Center>
);

InputSuffix.displayName = SUFFIX_ID;
Object.assign(InputSuffix, { id: SUFFIX_ID });

export default InputSuffix;
